import { type Component, type ComponentProps, splitProps } from "solid-js";
import { cn } from "@stockpilot/shared";

const Skeleton: Component<ComponentProps<"div">> = (props) => {
  const [local, rest] = splitProps(props, ["class"]);
  return <div class={cn("animate-shimmer rounded-md", local.class)} {...rest} />;
};

export { Skeleton };
